export default {
  state: {
    snackBar:{
        status: '',
        type: '',
        titleMessage: '',
        bodyMessage: '',
        cardColor: '',
        titleIcon:'',
    }
  },

  getters: {
    getSnackBarData(state){
       return state.snackBar
    },
  },

  mutations: {
    setSnackBarData(state, data){
      state.snackBar = data
    },
  },

  actions: {
    changeSnackBarData(context, infos){ 
      context.commit("setSnackBarData", infos)
    },
  },
};
